// extracted by mini-css-extract-plugin
export default {"container":"tB-z","contactUsLink":"uB-z"};